import { render } from "./AudienceIcon.vue?vue&type=template&id=66a80c86"
import script from "./AudienceIcon.vue?vue&type=script&lang=js"
export * from "./AudienceIcon.vue?vue&type=script&lang=js"
script.render = render

export default script